import {Component, OnInit} from '@angular/core';
import {ModalHelper} from '../../../services/modalService/modal.helper';

@Component({
  selector: 'create-account',
  templateUrl: './create-account.component.html',
  styleUrls: ['./create-account.component.css']
})
export class CreateAccountComponent implements OnInit {

  constructor(private modalHelper: ModalHelper) {
  }

  ngOnInit() {
  }

  createAccount() {
    this.modalHelper.openCreate({}, null);
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/create-account/create-account.component.ts